<ng-container *ngIf="showSkeleton; else actualContent">
  <div class="-search-card-container loader" *ngFor="let item of skeletonItems">
    <div class="-search-card-header">
      <div class="skeleton-loader skeleton-title"></div>
      <div class="skeleton-loader skeleton-tag"></div>
    </div>
    <div class="skeleton-loader skeleton-url"></div>
    <div class="skeleton-loader skeleton-excerpt"></div>
  </div>
</ng-container>
<ng-template #actualContent>
<app-link (preNavigate)="onCardClick()" linkmode="preNavigate" *ngIf="!toType || toType !== 'title'" [to]="isInternalDocumentUri ? searchCardResponse.documentBreadcrumbs : searchCardResponse.documentURI">
    <div *ngIf="searchCardResponse" class="-search-card-container">
      <div class="-search-card-header">
        <h3 [innerHTML]="title"></h3>
        <content-tag *ngIf="searchCardResponse.docCategory" [label]="searchCardResponse.docCategory"></content-tag>
      </div>
      <p class="-search-url">
        {{ searchCardResponse.documentBreadcrumbs }}
      </p>
      <p [innerHTML]="searchCardResponse.documentExcerpt"></p>
    </div>
</app-link>
<div *ngIf="toType === 'title' && searchCardResponse" class="-search-card-container">
    <div class="-search-card-header">
        <app-link (preNavigate)="onCardClick()" linkmode="preNavigate" [to]="isInternalDocumentUri ? searchCardResponse.documentBreadcrumbs : searchCardResponse.documentURI">
            <h3 [innerHTML]="title"></h3>
        </app-link>
        <content-tag *ngIf="searchCardResponse.docCategory" [label]="searchCardResponse.docCategory"></content-tag>
    </div>
    <p class="-search-url">
        {{ searchCardResponse.documentBreadcrumbs }}
    </p>
    <p [innerHTML]="searchCardResponse.documentExcerpt"></p>
</div>
</ng-template>